$shm_mentionstat_form $mol_form
	query? \
	excluded_words? \
	date_from? \
	date_to? \
	country? \
	language? \
	search_type? \
	tags? \
	category? \
	social_files? /File
	mass_files? /File
	social_existing_title \
	mass_existing_title \
	submit_title \Добавить
	submit? null
	reset? null
	form_fields /
		<= Query_field $mol_form_field
			name \Поисковой запрос
			bid <= query_bid \
			Content <= Query $mol_string
				value? <=> query? \
		<= Excluded_words_field $mol_form_field
			name \Минус-слова
			Content <= Excluded_words $mol_textarea
				value? <=> excluded_words? \
		<= Period_field $mol_form_field
			name \Период
			content /
				<= Period $shm_period
					date_from? <=> date_from? \
					date_to? <=> date_to? \
		<= Country_field $mol_form_field
			name \Страна
			Content <= Country $mol_string
				value? <=> country? \
		<= Language_field $mol_form_field
			name \Язык
			Content <= Language $mol_string
				value? <=> language? \
		<= Social_field $mol_form_field
			name \Соцмедиа
			bid <= files_bid \
			content /
				<= Social_upload $shm_file_drop
					accept \.csv,text/csv
					files? <=> social_files? /File
				<= Social_title $mol_view
					sub / <= social_title \
		<= Mass_field $mol_form_field
			name \СМИ
			bid <= files_bid \
			content /
				<= Mass_upload $shm_file_drop
					accept \.csv,text/csv
					files? <=> mass_files? /File
				<= Mass_title $mol_view
					sub / <= mass_title \
		<= Type_field $mol_form_field
			name \Тип
			Content <= Type $mol_select
				value? <=> search_type? \
				dictionary *
					инфоповод \инфоповод
					компания \компания
					персона \персона
					событие \событие
					процесс \процесс
					география \география
		<= Tags_field $mol_form_field
			name \Теги
			Content <= Tags $mol_string
				value? <=> tags? \
		<= Category_field $mol_form_field
			name \Категория
			Content <= Category $mol_string
				value? <=> category? \
	body /
		<= Query_group $mol_form_group
			sub /
				<= Query_field
				<= Excluded_words_field
		<= Period_field
		<= Locale_group $mol_form_group
			sub /
				<= Country_field
				<= Language_field
		<= Files_group $mol_form_group
			sub /
				<= Social_field
				<= Mass_field
		<= Meta_group $mol_form_group
			sub /
				<= Type_field
				<= Tags_field
				<= Category_field
	buttons /
		<= Submit $mol_button_major
			title <= submit_title
			enabled <= submit_allowed false
			click? <=> submit? null
		<= Reset $mol_button_minor
			title \Сбросить
			click? <=> reset? null
